(function () {
  const sectionObservers = new WeakMap();

  function findChatLauncher(root) {
    if (!root || !root.querySelectorAll) return null;

    const selectors = [
      '#ShopifyChat button',
      '#shopify-chat button',
      '[id*="shopify-chat" i] button',
      '[class*="shopify-chat" i] button',
      'button[aria-label*="chat" i]',
      '[role="button"][aria-label*="chat" i]',
      'button[title*="chat" i]',
      '[role="button"][title*="chat" i]',
      'button[aria-label*="message" i]',
      '[role="button"][aria-label*="message" i]',
      '[role="button"][title*="message" i]'
    ];

    for (const selector of selectors) {
      for (const candidate of root.querySelectorAll(selector)) {
        if (candidate.closest('.gs-contact')) continue;

        const style = window.getComputedStyle(candidate);
        const rect = candidate.getBoundingClientRect();
        if (style.display !== 'none' && style.visibility !== 'hidden' && rect.width && rect.height) {
          return candidate;
        }
      }
    }

    for (const element of root.querySelectorAll('*')) {
      if (element.shadowRoot) {
        const launcher = findChatLauncher(element.shadowRoot);
        if (launcher) return launcher;
      }
    }

    return null;
  }

  function openLiveChat(attempt = 0) {
    const launcher = findChatLauncher(document);
    if (launcher) {
      launcher.click();
      return;
    }

    if (attempt < 24) window.setTimeout(() => openLiveChat(attempt + 1), 250);
  }

  function initSection(section) {
    if (!section || section.dataset.gsContactReady === 'true') return;
    section.dataset.gsContactReady = 'true';

    section.querySelectorAll('[data-gs-live-chat]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        openLiveChat();
      });
    });

    section.querySelectorAll('a[href="#gs-contact-form"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const formPanel = section.querySelector('#gs-contact-form');
        if (!formPanel) return;

        event.preventDefault();
        formPanel.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'center'
        });
      });
    });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const animatedItems = section.querySelectorAll('.gs-scroll, .gs-scroll-left, .gs-scroll-right');
    if (!('IntersectionObserver' in window)) {
      animatedItems.forEach((item) => item.classList.add('gs-show'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('gs-show');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -30px 0px' });

    animatedItems.forEach((item) => observer.observe(item));
    sectionObservers.set(section, observer);
    section.classList.add('js-ready');
  }

  function initWithin(root) {
    if (root.matches?.('.gs-contact')) initSection(root);
    root.querySelectorAll?.('.gs-contact').forEach(initSection);
  }

  initWithin(document);
  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.matches?.('.gs-contact') ? event.target : event.target.querySelector?.('.gs-contact');
    const observer = section && sectionObservers.get(section);
    if (observer) observer.disconnect();
  });
})();
